import actions from './actions'
import getters from './getters'
import mutations from './mutations'

// 状態`Auth`と状態`Board`をVuexのstateで一元管理できるよう定義する
const state = { // 状態`Auth`
  token: localStorage.getItem('token'), // `token`は locale storage から取得する
  user: null // `userId`はnullで初期化
}

export default {
  namespaced: true,
  state, // 定義したstateを`state`オプションに指定
  getters,
  actions,
  mutations,
  strict: process.env.NODE_ENV !== 'production'
}



// WEBPACK FOOTER //
// ./src/store/modules/Auth/index.js